import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

const getUserPost=async (token) => {
    const response = await Api.get(REQUEST_URLS.GLOBAL.GET_USER_POSTS,{
        headers:{
            "Authorization": `Bearer ${token}`
        }
    });
    return response;

}
export default getUserPost;